<template>
  <div class="fiche-entreprise">
    <va-modal
      class="modal"
      v-model="showEntreprise"
      cancelText="Annuler"
      okText="Enregistrer"
      max-width="100%"
      v-on:ok="saveEntreprise"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
      disabled
    >
      <div class="forcewidth">
        <div class="row row-inside">
          <div class="flex md4">

            <span style="color: blue"><b>Participants</b> {{ entrepriseInfos.entreprise.nom }} <b> Formation</b> {{ entrepriseInfos.formation.formation_type.name }}</span>
          </div>
        </div>
        <va-separator />
        <div class="row row-inside">
          <div class="flex md11">
            <b>Collaborateurs</b>
          </div>
          <div class="flex md1">
            <va-popover
              message="Ajouter un collaborateur"
              placement="left"
            >
              <va-button
                color="info"
                @click="showAddSalarie=true"
                icon="fa fa-plus"
              >

              </va-button>
            </va-popover>
          </div>
          <div class="flex md12">
            <va-data-table
              class="va-table--hoverable va-table--stripped"
              :fields="fieldsCollaborateurs"
              :data="entrepriseInfos.collaborateurs"
              no-data-label="Aucun Collaborateur Enregistré"
              :per-page="parseInt(perPage)"
              @row-clicked="openSalarie"
              clickable
            >
              <template
                slot="actions"
                slot-scope="props"
              >
                <va-button
                  class="ma-0"
                  small
                  icon="fa fa-pencil"
                  @click.stop="openUpdateSalarie(props.rowData)"
                />
              </template>
              <template
                slot="participation"
                slot-scope="props"
              >
                <va-toggle
                  small
                  v-model="props.rowData.formationParticipation"
                />
              </template>

            </va-data-table>
          </div>
        </div>
      </div>
    </va-modal>
    <fiche-creation-salarie
      v-model="showAddSalarie"
      :identreprise="identreprise"
      @created="addCollaborateur"
    />
    <update-salarie
      v-model="showUpdateSalarie"
      :salarie="selectedCollaborateur"
      @updated="handleSalarieUpdated"
    />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ficheCreationSalarie from "./fiche-creation-salarie.vue";
import updateSalarie from "./update-salarie.vue";

export default {
  name: "fiche-entreprise",
  props: ["value", "identreprise", "idformation"],
  components: {
    ficheCreationSalarie,
    updateSalarie,
  },
  data() {
    return {
      perPage: 10,
      showAddSalarie: false,
      showEntreprise: false,
      showUpdateSalarie: false,
      selectedCollaborateur: null,
      isSavingParticipation: false,
      participationSaveTimer: null,
      entrepriseInfos: {
        identreprise: "",
        idformation: "",
        entreprise: {
          nom: "",
        },
        formation: {
          formation_type: {
            niveau: "",
            nom: "",
          },
        },
        collaborateurs: [],

      },
    };
  },
  methods: {
    openSalarie() {
      console.log("openSalarie");
    },
    openUpdateSalarie(collaborateur) {
      this.selectedCollaborateur = collaborateur;
      this.showUpdateSalarie = true;
    },
    async handleSalarieUpdated() {
      await this.getInfos();
    },
    async addCollaborateur(infos) {
      console.log("addColaborateur", infos);
      await this.getInfos();
      const existingIndex = this.entrepriseInfos.collaborateurs.findIndex((collaborateur) => {
        if (collaborateur.idsalarie && infos.idsalarie) {
          return collaborateur.idsalarie == infos.idsalarie;
        }
        if (collaborateur.idformation_salarie && infos.idformation_salarie) {
          return collaborateur.idformation_salarie == infos.idformation_salarie;
        }
        if (collaborateur.id_salarie && infos.id_salarie) {
          return collaborateur.id_salarie == infos.id_salarie;
        }
        if (collaborateur.idcollaborateur && infos.idcollaborateur) {
          return collaborateur.idcollaborateur == infos.idcollaborateur;
        }
        return (
          collaborateur.nom === infos.nom &&
          collaborateur.prenom === infos.prenom
        );
      });

      if (existingIndex !== -1) {
        this.entrepriseInfos.collaborateurs[existingIndex].formationParticipation = true;
      }
      this.saveParticipationOnly();
    },
    async getInfos() {
      let res = await axios.get("/api/afpf/entreprise-infos", {
        params: {
          identreprise: this.identreprise,
          idformation: this.idformation
        }
      });

      res.data.collaborateurs.forEach(element => {
        if (element.id_participation) {
          element.formationParticipation = true;
        } else {
          element.formationParticipation = false;
        }
      });

      this.entrepriseInfos = res.data
      console.log("getInfos");
    },
    async saveEntreprise() {
      console.log("saveEntreprise");
      try {
        await axios.patch("/api/afpf/update-participation-entreprise", this.entrepriseInfos);

        this.$emit("updated", true)
        this.$emit("input", false);
      } catch (error) {
        this.launchToast("Erreur lors de l'enregistrement");
      }


    },
    saveParticipationOnly() {
      if (this.participationSaveTimer) {
        clearTimeout(this.participationSaveTimer);
      }
      this.participationSaveTimer = setTimeout(async () => {
        if (this.isSavingParticipation) {
          return;
        }
        this.isSavingParticipation = true;
        try {
          await axios.patch("/api/afpf/update-participation-entreprise", this.entrepriseInfos);
          this.$emit("updated", true);
        } catch (error) {
          this.launchToast("Erreur lors de l'enregistrement");
        } finally {
          this.isSavingParticipation = false;
          this.participationSaveTimer = null;
        }
      }, 250);
    },
    closeModal() {
      this.$emit("input", false);
    },
    launchToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  mounted() {
    this.showEntreprise = this.value;
  },
  watch: {
    value() {
      // Parent property changed; update internal variables
      this.showEntreprise = this.value;
      //  this.resetValues();
      if (this.value) {
        this.getInfos();
      }
    }
  },
  computed: {
    fieldsCollaborateurs() {
      return [
        {
          name: "prenom",
          title: "Prénom",
          sortField: "prenom",
          width: "10%",
        },
        {
          name: "nom",
          title: "Nom",
          sortField: "nom",
          width: "20%",
        },
        {
          name: "birthdate",
          title: "Date de Naissance",
          sortField: "birthdate",
          width: "20%",
        },
        {
          name: "statut",
          title: "Statut",
          sortField: "statut",
          width: "20%",
        },
        {
          name: "__slot:participation",
          title: "Participation",
          width: "20%",
        },
        {
          name: "__slot:actions",
          title: "Actions",
          width: "10%",
        },
      ];
    },
  }

}
</script>

<style>
</style>
